import { Theme } from "@screencloud/screencloud-ui-components";
import styled from "styled-components";

export const DesignMyScreenContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 70px);
  overflow: hidden;
`;

export const DesignMyScreenModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  padding: 0 50px;
  margin: 0 -50px;
`;

export const TopSection = styled.div`
  padding: 24px 50px;
  border-bottom: 1px solid var(--color-gray-200, #c5c6ca);
  background-color: var(--color-white-100, #fff);
  .step-progress {
    width: 30%;
  }
`;

export const MiddleSection = styled.div`
  flex: 1;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const BottomSection = styled.div<{ isFirstStep: boolean }>`
  display: flex;
  border-top: 1px solid var(--color-gray-200, #c5c6ca);
  justify-content: ${({ isFirstStep }) =>
    isFirstStep ? "flex-end" : "space-between"};
  padding: var(--spacing-lg) var(--spacing-xxl);

  @media (max-width: ${Theme.break.small}) {
    position: fixed;
    bottom: 0;
    right: 0;
    width: 100%;
    background: white;
    z-index: 2;
  }
`;

export const GeneratingContentModal = styled.div`
  display: flex;
  padding: 16px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;

  color: var(--color-gray-950, #19191b);
  text-align: center;
  font-size: var(--font-size-lg, 20px);
  font-weight: 900;
  line-height: var(--font-line-height-lg, 28px);
`;
